import { FullModal } from '@sbt-web/ui';
import React from 'react';
import { getPublicUser } from './PublicUserProvider.js';

var LoginTemplate;
(function (LoginTemplate) {
    LoginTemplate["Favorites"] = "favorites";
    LoginTemplate["MySearches"] = "mysearches";
    LoginTemplate["AdReply"] = "adreply";
    LoginTemplate["AdAbuse"] = "adabuse";
    LoginTemplate["AdBuy"] = "adbuy";
})(LoginTemplate || (LoginTemplate = {}));
var LoginInPlaceEvents;
(function (LoginInPlaceEvents) {
    LoginInPlaceEvents["LoginSuccess"] = "sbtLoginSuccessful";
    LoginInPlaceEvents["Resize"] = "subito:LoginInplace:resize";
    LoginInPlaceEvents["PhoneVerification"] = "subito:LoginInplace:phoneVerification";
    LoginInPlaceEvents["MustResetPassword"] = "subito:LoginInplace:mustResetPassword";
})(LoginInPlaceEvents || (LoginInPlaceEvents = {}));
const newPage = {
    desktopWidth: 786,
    desktopHeight: 660,
    desktopNoTemplateHeight: 530,
    desktopNoTemplateWidth: 320,
    mobileWidth: '100%',
    // 100px is the height of the header
    mobileHeight: 'calc(100vh - 100px)',
};
const oldPage = {
    desktopWidth: 800,
    desktopHeight: 450,
    desktopNoTemplateHeight: 450,
    desktopNoTemplateWidth: 274,
    mobileWidth: '100%',
    // 100px is the height of the header
    mobileHeight: 'calc(100vh - 100px)',
};
class LoginInPlaceComponent extends React.Component {
    state = {
        iframeSource: '',
        iframeHeight: undefined,
    };
    componentDidUpdate() {
        const { opened } = this.props;
        const { iframeSource: prevIframeSource } = this.state;
        const iframeSource = this.buildIframeSource();
        if (opened && (!prevIframeSource || iframeSource !== prevIframeSource)) {
            this.setState({ iframeSource });
        }
    }
    componentDidMount() {
        window.addEventListener('message', this.messageListener);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageListener);
    }
    render() {
        const { opened, onCloseIntent, isMobile, template } = this.props;
        const iframe = this.renderIframe();
        return (React.createElement(FullModal, { onClose: onCloseIntent, open: opened, inset: true, title: isMobile ? 'Login' : '', size: isMobile || !template ? 'small' : 'large' },
            React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'center' } }, iframe)));
    }
    renderIframe = () => {
        const { iframeSource, iframeHeight } = this.state;
        const iframeDimension = this.buildIframeDimension();
        if (!iframeSource) {
            return null;
        }
        const { template, isMobile, opened } = this.props;
        const styles = { display: 'block', border: 'none' };
        if (!isMobile) {
            styles.width = iframeDimension.desktopNoTemplateWidth;
            styles.height = iframeHeight ?? iframeDimension.desktopNoTemplateHeight;
            if (template) {
                styles.width = iframeDimension.desktopWidth;
                styles.height = iframeHeight ?? iframeDimension.desktopHeight;
            }
        }
        else {
            styles.width = iframeDimension.mobileWidth;
            styles.height = iframeHeight ?? iframeDimension.mobileHeight;
        }
        if (!opened) {
            styles.display = 'none';
        }
        return (React.createElement("iframe", { title: "logininplace-iframe", key: iframeSource, src: iframeSource, style: styles, scrolling: "no" }));
    };
    buildIframeSource = () => {
        const { reservedAreaBase, template, enableNewPage } = this.props;
        let url = `${reservedAreaBase}/login_inplace${template ? `?tmpl=${template}` : ''}`;
        if (enableNewPage) {
            url = `${reservedAreaBase}/login_in_place${template ? `?tmpl=${template}` : ''}`;
        }
        return url;
    };
    buildIframeDimension = () => {
        const { enableNewPage } = this.props;
        if (enableNewPage) {
            return newPage;
        }
        return oldPage;
    };
    messageListener = (e) => {
        const { onLogin } = this.props;
        if (e.data === LoginInPlaceEvents.LoginSuccess) {
            onLogin(getPublicUser());
        }
        else if (e.data?.event === LoginInPlaceEvents.Resize) {
            const height = e.data?.payload?.height;
            this.setState({
                iframeHeight: height,
            });
        }
        else if (e.data?.event === LoginInPlaceEvents.PhoneVerification) {
            const phoneVerificationURL = new URL(`${this.props.reservedAreaBase}/verifica-telefonica`);
            phoneVerificationURL.searchParams.append('token', e.data.payload?.token);
            phoneVerificationURL.searchParams.append('user-id', e.data.payload?.userId);
            if (e.data.payload.credentialsType) {
                phoneVerificationURL.searchParams.append('credentials_type', e.data.payload.credentialsType);
            }
            phoneVerificationURL.searchParams.append('back', window.location.href);
            phoneVerificationURL.searchParams.append('utm_medium', 'other');
            phoneVerificationURL.searchParams.append('utm_source', 'subito');
            phoneVerificationURL.searchParams.append('utm_campaign', 'free-engagement-verify_phone');
            window.location.assign(phoneVerificationURL.href);
        }
        else if (e.data?.event === LoginInPlaceEvents.MustResetPassword) {
            const expiredPasswordURL = new URL(`${this.props.reservedAreaBase}/password-scaduta`);
            expiredPasswordURL.searchParams.append('email', e.data.payload?.email);
            window.location.assign(expiredPasswordURL.href);
        }
    };
}
const LoginInPlace = LoginInPlaceComponent;

export { LoginInPlace, LoginInPlaceComponent, LoginInPlaceEvents, LoginTemplate };
//# sourceMappingURL=LoginInPlace.js.map
